import { CustomRoute } from '@app/components/layout/sidebar/components/route';
import { Route } from 'react-router-dom';
import CheckEmailPage from './email-verification/check-email-page';
import AssessmentsGuide from './guide/assessments-guide';
import GetInTouch from './guide/get-in-touch';
import OnboardingGuideLayout from './guide/onboarding-guide-layout';
import ProductsGuide from './guide/products-guide';
import ReportsGuide from './guide/reports-guide';
import WelcomePage from './guide/welcome-page';
import AboutCompanyPage from './signup/additional-signup-steps/about-company-page';
import CompanyAimsPage from './signup/additional-signup-steps/company-aims-page';
import SignupFlowLayout from './signup/signup-flow-layout';

export const onboardingRoutes = {
  ONBOARDING_GUIDE_WELCOME: '/guide/welcome',
  ONBOARDING_GUIDE_PRODUCTS: '/guide/products',
  ONBOARDING_GUIDE_ASSESSMENTS: '/guide/assessments',
  ONBOARDING_GUIDE_REPORTS: '/guide/reports',
  ONBOARDING_GUIDE_GET_IN_TOUCH: '/guide/get-in-touch',

  SIGNUP_ABOUT_COMPANY: '/sign-up/about-company',
  SIGNUP_COMPANY_AIMS: '/sign-up/company-aims',
  SIGNUP_CHECK_EMAIL: '/verify-email',
};

export function OnboardingRoutes() {
  return (
    <Route
      element={
        <CustomRoute element={<OnboardingGuideLayout />} hasSidebar={false} />
      }
    >
      <Route
        path={onboardingRoutes.ONBOARDING_GUIDE_WELCOME}
        element={<WelcomePage />}
      />
      <Route
        path={onboardingRoutes.ONBOARDING_GUIDE_PRODUCTS}
        element={<ProductsGuide />}
      />
      <Route
        path={onboardingRoutes.ONBOARDING_GUIDE_ASSESSMENTS}
        element={<AssessmentsGuide />}
      />
      <Route
        path={onboardingRoutes.ONBOARDING_GUIDE_REPORTS}
        element={<ReportsGuide />}
      />
      <Route
        path={onboardingRoutes.ONBOARDING_GUIDE_GET_IN_TOUCH}
        element={<GetInTouch />}
      />
    </Route>
  );
}

export function SignupRoutes() {
  return (
    <Route
      element={
        <CustomRoute element={<SignupFlowLayout />} hasSidebar={false} />
      }
    >
      <Route
        path={onboardingRoutes.SIGNUP_ABOUT_COMPANY}
        element={<AboutCompanyPage />}
      />
      <Route
        path={onboardingRoutes.SIGNUP_COMPANY_AIMS}
        element={<CompanyAimsPage />}
      />
      <Route
        path={onboardingRoutes.SIGNUP_CHECK_EMAIL}
        element={<CheckEmailPage />}
      />
    </Route>
  );
}
